<template>
  <div id="login" :style="{ backgroundImage: `url(${meta.bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
    <img :src="meta.logo" alt="" id="logo">

    <div class="card">
      <div @click="goToReg" class="title-btn">
        {{ $t('login["Register"]') }}
      </div>
      <div class="login-title">
        {{ $t('forget_pwd["Forget"]') }}
        <span class="marked">{{ $t('update_pwd["Password"]') }}</span>
      </div>

      <div class="form-item">
        <input :placeholder="$t('login[\'Please enter your email address\']')" type="text" class="emailAddress" v-model="form.email">
      </div>

      <div class="form-item flex-row">
        <input :placeholder="$t('login[\'Enter code\']')" type="text" v-model="form.code">
        <button class="btn btn-get-code" @click="getCode">{{ $t('login["Get code"]') }}</button>
      </div>

      <div class="form-item">
        <input :placeholder="$t('update_pwd[\'Please enter your new password\']')" type="password" class="emailAddress" v-model="form.pwd">
      </div>

      <div class="form-item">
        <input :placeholder="$t('update_pwd[\'Please confirm your new password\']')" type="password" class="emailAddress" v-model="form.pwd2">
      </div>

      <div class="form-item">
        <button class="btn btn-change-pwd" @click="doChangePwd">
          {{ $t('forget_pwd["Change Password"]') }}
        </button>
      </div>
    </div>

    <div class="footer-space"></div>

    <custom-dialog
      v-model="showDialog"
      width="500"
      :confirmText="$t('base.ok')"
      cancelType="primary"
      @confirm="confirmModel"
      @change="changeModel"
      :title="$t('base.notice')">
      <div>
        {{ confirmInfo }}
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import meta from '../../utils/meta'
import axios from "../../utils/request";
import CustomDialog from "../../components/alert.vue";

export default {
  name: 'forget_pwd',
  components: { CustomDialog },
  data() {
    return {
      showDialog: false,
      confirmInfo: '',
      form: {
        code: '',
        email: '',
        pwd: '',
        pwd2: '',
      },
      meta
    }
  },
  methods: {
    doChangePwd() {
      axios({
        method: "post",
        url: '/updatePwdByEmailCode',
        data: this.form
      }).then(({code, msg, data}) => {
        if (code === 200) {
          this.$message.success(this.$t('base.successfully'))
          this.$router.push('/login')
        } else {
          this.showDialog = true
          this.confirmInfo = msg
        }
      })
    },
    changeModel() {
      this.showDialog = false
    },
    confirmModel() {
      this.showDialog = false
    },
    getCode() {
      axios({
        method: "get",
        url: '/businese/user_info/sendUpdateCode?email=' + this.form.email,
      }).then(({code, msg, data}) => {
        if (code === 200) {
          this.$message({
            message: this.$t('login["Email sent successfully"]'),
            type: 'success'
          });
        } else {
          this.showDialog = true
          this.confirmInfo = msg
        }
      })
    },
    goToReg() {
      this.$router.push('/reg')
    }
  }
}
</script>

<style scoped>
.footer-space {
  height: 200px;
  width: 100px;
}

.marked {
  font-size: 28px;
  color:#FF5E00
}

.form-item {
  display: flex;
  margin-bottom: 4vw;
}

#login {
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  text-align: center;
  position: relative;
  background-attachment: fixed;
  z-index: 1;
}

#logo {
  width: 198px;
  height: 48px;
  margin: 80px 0 41px 0;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-row > * {
  flex: 1;
}

.card {
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FEF1 100%);
  box-shadow: 0 7px 13px 0 rgba(5, 78, 171, 0.33);
  margin: 0 20px;
  border-radius: 25px;
  position: relative;
  padding: 1vw 3.73vw 6vw;
}

input {
  height: 52px;
  border-radius: 16px;
  padding: 0 15px;
  border: 1px solid #C8C8C8;
  min-width: 0;
  flex: 1;
}

.login-title {
  height: 40px;
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  padding-left: 21px;
  padding-top: 27px;
  padding-bottom: 26px;
}

.btn {
  background: linear-gradient(133deg, #F8B029 0%, #F6923D 100%);
  font-weight: 600;
  font-size: 1.2rem;
  color: #FFFFFF;
  text-align: center;
  border: none;
  flex: auto;
}

.btn-change-pwd {
  height: 58px;
  line-height: 58px;
  border-radius: 20px;
  padding: 0 20px;
}

.btn-get-code {
  border-radius: 18px;
  line-height: 52px;
  margin-left: 12px;
  font-size: 1rem;
  padding: 0 16px;
  flex: 0 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/forget_pwd/index.vue